import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400" }, "@", -1)
const _hoisted_2 = { class: "underline" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: {
      name: 'overview',
      params: {
        network: _ctx.network,
        account: _ctx.account,
      },
    },
    class: _normalizeClass(["whitespace-nowrap", {
      'text-blue-700 hover:text-blue-500 dark:text-blue-400 dark:hover:text-blue-300':
        !_ctx.theme,
      'text-blue-700 hover:text-blue-500': _ctx.theme === 'light',
      'text-blue-400 hover:text-blue-300': _ctx.theme === 'dark',
    }])
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.account), 1)
    ]),
    _: 1
  }, 8, ["to", "class"]))
}